<app-progress id="progreso" *ngIf="datosSubidaService.datosProcesoServidor.codigoSubida>0"[porcentajeSubida]="avance" [mensjeCompletado]="mensajeCompletado" [mensjeProgreso]="mensajeProcesando" (linkClicked)="iraDetalle()"></app-progress>
